import { createSelector } from '@reduxjs/toolkit';
import { theme } from 'antd';
import dayjs from 'dayjs';
import { reduxEqualityFunction } from 'library/helpers/utility';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Col, Flex, Row, Typography } from 'zui/Antd';
import ViewMoreToggle from '../ViewMoreToggle';
import { peopleActions } from 'reduxStore/people/slice';

const { Text } = Typography;

//TODO : move this into a selector file
// Selector to get person by ID
const selectPersonByID = createSelector(
	[(state) => state.People.data, (_, personID) => personID],
	(people, personID) => people.find((person) => person.personID === personID) || {}
);

const PeopleBookingsPanel = ({ personID }) => {
	const dispatch = useDispatch();

	// Styles from theme
	const {
		token: { paddingMD, paddingSM }
	} = theme.useToken();

	// Local State
	const [showAll, setShowAll] = useState(false);
	const maxItemsToShow = 4;

	// Get person by ID
	const person = useSelector((state) => selectPersonByID(state, personID), {
		equalityFn: reduxEqualityFunction
	});

	// Load bookings data on component mount
	useEffect(() => {
		dispatch(peopleActions.loadPeopleBooking({ personID }));
	}, [personID, dispatch]);

	// Get visible bookings
	const visibleBookings = showAll ? person.bookings?.data : person.bookings?.data.slice(0, maxItemsToShow);

	return (
		<Fragment>
			{/* // If no bookings data is available, return null */}
			{visibleBookings?.length === 0 && <Text type='secondary'>No bookings available.</Text>}

			<Row gutter={[16, 16]}>
				{visibleBookings &&
					visibleBookings.length > 0 &&
					visibleBookings.map((booking) => (
						<Col span={24} key={booking.bookingID}>
							<Card
								title={booking.deviceName}
								styles={{
									header: {
										border: 'none',
										minHeight: 'auto',
										padding: `${paddingSM}px ${paddingMD}px`
									},
									body: {
										padding: `0px ${paddingMD}px`
									}
								}}
							>
								<Row justify={'space-between'}>
									<Col span={12}>
										<Flex vertical align='flex-start'>
											<Text type='secondary'>From</Text>
											<Text strong>{dayjs(booking.startTime).format('DD/MM/YYYY')}</Text>
										</Flex>
									</Col>
									<Col span={12}>
										<Flex vertical align='flex-end'>
											<Text type='secondary'>Until</Text>
											<Text strong>{dayjs(booking.endTime).format('DD/MM/YYYY')}</Text>
										</Flex>
									</Col>
								</Row>
							</Card>
						</Col>
					))}
			</Row>

			{/* View More / View Less toggle */}
			{person.bookings?.length > maxItemsToShow && (
				<ViewMoreToggle
					data={person.bookings?.data}
					maxItemsToShow={maxItemsToShow}
					onToggle={(showAll) => setShowAll(showAll)}
				/>
			)}
		</Fragment>
	);
};

export default PeopleBookingsPanel;
